import { render, staticRenderFns } from "./SendMailForm.vue?vue&type=template&id=8e9f3f46&scoped=true&"
import script from "./SendMailForm.vue?vue&type=script&lang=ts&"
export * from "./SendMailForm.vue?vue&type=script&lang=ts&"
import style0 from "./SendMailForm.vue?vue&type=style&index=0&id=8e9f3f46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9f3f46",
  null
  
)

export default component.exports